import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class BomService {
  url :string = environment.url;
  urlV2 :string = environment.urlV2;

  constructor(private http :HttpClient) {}

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.http.get(`${this.urlV2}/bom`, { params: params });
  }
}
